import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1ca83158")

_pushScopeId("data-v-1ca83158")
const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_encashment_process",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header flex-stack" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body scroll-y pt-10 pb-15 px-lg-17" }
const _hoisted_9 = { class: "card-body py-3" }
const _hoisted_10 = {
  key: 0,
  class: "col-xxl-12"
}
const _hoisted_11 = {
  key: 0,
  class: "row mb-5"
}
const _hoisted_12 = { class: "table-responsive" }
const _hoisted_13 = { class: "table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4" }
const _hoisted_14 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "border-0" }, [
    /*#__PURE__*/_createVNode("th", { class: "p-0 max-w-50px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 max-w-50px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 max-w-50px" })
  ])
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("p", { style: {"text-align":"center"} }, [
    /*#__PURE__*/_createVNode("span", { class: "text-success fw-bold d-block" }, "  Total Balance")
  ])
], -1)
const _hoisted_16 = { style: {"text-align":"center"} }
const _hoisted_17 = { class: "text-dark fw-bolder text-hover-primary mb-1 fs-6" }
const _hoisted_18 = /*#__PURE__*/_createVNode("td", { class: "text-end" }, null, -1)
const _hoisted_19 = {
  key: 0,
  id: "mlcRow"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("p", { style: {"text-align":"center"} }, [
    /*#__PURE__*/_createVNode("span", null, [
      /*#__PURE__*/_createVNode("img", { src: "/media/logos/networksales-c.png" })
    ]),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createVNode("span", { class: "text-success fw-bold d-block" }, "  Group Sales Commission")
  ])
], -1)
const _hoisted_21 = { style: {"text-align":"center"} }
const _hoisted_22 = { class: "text-dark fw-bolder text-hover-primary mb-1 fs-6" }
const _hoisted_23 = { class: "text-end" }
const _hoisted_24 = { style: {"text-align":"center"} }
const _hoisted_25 = {
  key: 1,
  id: "drcRow"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("p", { style: {"text-align":"center"} }, [
    /*#__PURE__*/_createVNode("span", null, [
      /*#__PURE__*/_createVNode("img", { src: "/media/logos/personalsales-c.png" })
    ]),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createVNode("span", { class: "text-success fw-bold d-block" }, "  Personal Direct Sales Commission")
  ])
], -1)
const _hoisted_27 = { style: {"text-align":"center"} }
const _hoisted_28 = { class: "text-dark fw-bolder text-hover-primary mb-1 fs-6" }
const _hoisted_29 = { class: "text-end" }
const _hoisted_30 = { style: {"text-align":"center"} }
const _hoisted_31 = {
  key: 1,
  class: "row mb-5"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-1" }, null, -1)
const _hoisted_33 = { class: "col-md-6 fv-row py-1" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-1" }, null, -1)
const _hoisted_35 = { class: "row mb-5" }
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-1" }, null, -1)
const _hoisted_37 = { class: "col-md-6 fv-row py-1" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = /*#__PURE__*/_createVNode("option", { value: "XXX" }, "Encashment Type", -1)
const _hoisted_40 = {
  key: 0,
  value: "B"
}
const _hoisted_41 = {
  key: 1,
  value: "C"
}
const _hoisted_42 = {
  key: 2,
  value: "S"
}
const _hoisted_43 = {
  key: 3,
  value: "R"
}
const _hoisted_44 = {
  key: 4,
  value: "E"
}
const _hoisted_45 = {
  key: 5,
  value: "T"
}
const _hoisted_46 = {
  key: 6,
  value: "M"
}
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-1" }, null, -1)
const _hoisted_48 = {
  key: 2,
  class: "row mb-5",
  id: "divChequeBranch"
}
const _hoisted_49 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-1" }, null, -1)
const _hoisted_50 = { class: "col-md-6 fv-row py-1" }
const _hoisted_51 = /*#__PURE__*/_createVNode("option", { value: "XXX" }, "Select Branch", -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-1" }, null, -1)
const _hoisted_53 = {
  key: 3,
  class: "row mb-5 text-center"
}
const _hoisted_54 = { class: "text-center" }
const _hoisted_55 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_56 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Your Bank Account(s)", -1)
const _hoisted_57 = { class: "mt-5 mb-5" }
const _hoisted_58 = {
  key: 1,
  class: "card"
}
const _hoisted_59 = { class: "card-body p-5" }
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "mb-3" }
const _hoisted_62 = {
  key: 1,
  class: "btn btn-sm btn-primary",
  type: "button"
}
const _hoisted_63 = {
  key: 4,
  class: "row mb-5",
  id: "divCashBranch"
}
const _hoisted_64 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-1" }, null, -1)
const _hoisted_65 = { class: "col-md-6 fv-row py-1" }
const _hoisted_66 = /*#__PURE__*/_createVNode("option", { value: "XXX" }, "Select Branch", -1)
const _hoisted_67 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-1" }, null, -1)
const _hoisted_68 = {
  key: 5,
  class: "row mb-5",
  id: "encashment_buttons"
}
const _hoisted_69 = { class: "col-md-12 fv-row py-1 text-center" }
const _hoisted_70 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_71 = {
  key: 6,
  class: "row mb-5",
  id: "encashment_confirmation"
}
const _hoisted_72 = { class: "row mb-5" }
const _hoisted_73 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-1 text-center" }, null, -1)
const _hoisted_74 = { class: "col-md-8 fv-row py-1" }
const _hoisted_75 = /*#__PURE__*/_createVNode("p", null, "This encashment will use the details below: ", -1)
const _hoisted_76 = /*#__PURE__*/_createTextVNode("Bank: ")
const _hoisted_77 = { id: "bank" }
const _hoisted_78 = /*#__PURE__*/_createTextVNode("Account Number: ")
const _hoisted_79 = { id: "acctno" }
const _hoisted_80 = /*#__PURE__*/_createVNode("p", null, "Click proceed if all details are correct.", -1)
const _hoisted_81 = /*#__PURE__*/_createVNode("div", { class: "col-md-1 fv-row py-1 text-center" }, null, -1)
const _hoisted_82 = { class: "row mb-5" }
const _hoisted_83 = { class: "col-md-12 fv-row py-1 text-center" }
const _hoisted_84 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_85 = {
  key: 7,
  class: "row mb-5",
  id: "encashment_confirmation"
}
const _hoisted_86 = { class: "row mb-5" }
const _hoisted_87 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-1 text-center" }, null, -1)
const _hoisted_88 = { class: "col-md-8 fv-row py-1" }
const _hoisted_89 = /*#__PURE__*/_createVNode("p", null, "This encashment will use the details below: ", -1)
const _hoisted_90 = /*#__PURE__*/_createTextVNode("Mobile Number: ")
const _hoisted_91 = { id: "bibo_mobile" }
const _hoisted_92 = /*#__PURE__*/_createVNode("p", null, "Click proceed if all details are correct.", -1)
const _hoisted_93 = /*#__PURE__*/_createVNode("div", { class: "col-md-1 fv-row py-1 text-center" }, null, -1)
const _hoisted_94 = { class: "row mb-5" }
const _hoisted_95 = { class: "col-md-12 fv-row py-1 text-center" }
const _hoisted_96 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_97 = {
  key: 8,
  class: "row mb-5",
  id: "encashment_confirmation"
}
const _hoisted_98 = { class: "row mb-5" }
const _hoisted_99 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-1 text-center" }, null, -1)
const _hoisted_100 = { class: "col-md-8 fv-row py-1" }
const _hoisted_101 = /*#__PURE__*/_createVNode("p", null, "This encashment will use the details below: ", -1)
const _hoisted_102 = /*#__PURE__*/_createTextVNode("Mobile Number: ")
const _hoisted_103 = { id: "mobile_money_accountno" }
const _hoisted_104 = /*#__PURE__*/_createVNode("p", null, "Click proceed if all details are correct.", -1)
const _hoisted_105 = /*#__PURE__*/_createVNode("div", { class: "col-md-1 fv-row py-1 text-center" }, null, -1)
const _hoisted_106 = { class: "row mb-5" }
const _hoisted_107 = { class: "col-md-12 fv-row py-1 text-center" }
const _hoisted_108 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_109 = {
  key: 9,
  class: "row mb-5",
  id: "encashment_CHEQUEconfirmation"
}
const _hoisted_110 = { class: "row mb-5" }
const _hoisted_111 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-1 text-center" }, null, -1)
const _hoisted_112 = { class: "col-md-8 fv-row py-1" }
const _hoisted_113 = /*#__PURE__*/_createVNode("p", { class: "dashboardFontStyle" }, "This encashment will use the details below: ", -1)
const _hoisted_114 = { class: "dashboardFontStyle" }
const _hoisted_115 = /*#__PURE__*/_createTextVNode("First Name: ")
const _hoisted_116 = { id: "fnameCHEQUE" }
const _hoisted_117 = { class: "dashboardFontStyle" }
const _hoisted_118 = /*#__PURE__*/_createTextVNode("Last Name: ")
const _hoisted_119 = { id: "lnameCHEQUE" }
const _hoisted_120 = {
  key: 0,
  class: "dashboardFontStyle"
}
const _hoisted_121 = /*#__PURE__*/_createVNode("p", { class: "dashboardFontStyle" }, "Check the checkbox below if all details are correct. And then click Proceed button.", -1)
const _hoisted_122 = /*#__PURE__*/_createVNode("div", { class: "col-md-1 fv-row py-1 text-center" }, null, -1)
const _hoisted_123 = { class: "row mb-5 text-center" }
const _hoisted_124 = { for: "checkboxCHEQUE" }
const _hoisted_125 = /*#__PURE__*/_createTextVNode(" All details are correct.")
const _hoisted_126 = { class: "row mb-5" }
const _hoisted_127 = { class: "col-md-12 fv-row py-1 text-center" }
const _hoisted_128 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_129 = {
  key: 10,
  class: "row mb-5",
  id: "encashment_CASHconfirmation"
}
const _hoisted_130 = { class: "row mb-5" }
const _hoisted_131 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-1 text-center" }, null, -1)
const _hoisted_132 = { class: "col-md-8 fv-row py-1" }
const _hoisted_133 = {
  key: 0,
  class: "dashboardFontStyle"
}
const _hoisted_134 = {
  key: 1,
  class: "dashboardFontStyle"
}
const _hoisted_135 = /*#__PURE__*/_createVNode("div", { class: "col-md-1 fv-row py-1" }, null, -1)
const _hoisted_136 = { class: "row mb-5" }
const _hoisted_137 = { class: "col-md-12 fv-row py-1 text-center" }
const _hoisted_138 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_139 = {
  key: 1,
  class: "col-xxl-12"
}
const _hoisted_140 = /*#__PURE__*/_createVNode("div", { class: "row mb-5" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-md-12 fv-row py-1" }, [
    /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold mb-2" }, [
      /*#__PURE__*/_createVNode("span", { class: "" }, "Please input the Chinatrust OTP sent to your mobile phone.")
    ])
  ])
], -1)
const _hoisted_141 = { class: "row mb-5" }
const _hoisted_142 = { class: "col-md-12 fv-row py-1" }
const _hoisted_143 = { class: "row mb-5" }
const _hoisted_144 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-1 text-center" }, null, -1)
const _hoisted_145 = { class: "col-md-6 fv-row py-1 text-center" }
const _hoisted_146 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-1 text-center" }, null, -1)
const _hoisted_147 = {
  key: 2,
  class: "col-xxl-12"
}
const _hoisted_148 = {
  key: 0,
  class: "row mb-5"
}
const _hoisted_149 = /*#__PURE__*/_createVNode("div", { class: "col-md-12 fv-row py-1" }, [
  /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold mb-2" }, [
    /*#__PURE__*/_createVNode("span", { class: "" }, "Please input the OTP sent to your mobile phone.")
  ])
], -1)
const _hoisted_150 = {
  key: 1,
  class: "row mb-5"
}
const _hoisted_151 = { class: "col-md-12 fv-row py-1 text-center" }
const _hoisted_152 = {
  key: 2,
  class: "row mb-5"
}
const _hoisted_153 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-3 text-center" }, null, -1)
const _hoisted_154 = { class: "col-md-6 fv-row py-6 text-center" }
const _hoisted_155 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-3 text-center" }, null, -1)
const _hoisted_156 = {
  key: 3,
  class: "row mb-5"
}
const _hoisted_157 = /*#__PURE__*/_createVNode("p", null, "1) Please upload (1) valid ID.", -1)
const _hoisted_158 = {
  key: 4,
  class: "row mb-5"
}
const _hoisted_159 = /*#__PURE__*/_createVNode("p", null, "2) Please upload a selfie while holding your valid ID.", -1)
const _hoisted_160 = {
  key: 5,
  class: "row mb-5"
}
const _hoisted_161 = /*#__PURE__*/_createTextVNode("Uploading. Please wait...")
const _hoisted_162 = {
  key: 3,
  class: "col-xxl-12"
}
const _hoisted_163 = { class: "row mb-5 text-center" }
const _hoisted_164 = /*#__PURE__*/_createVNode("p", null, "Before we continue with your encashment, please update first your address (State/Region and your LGA) in the Profile Menu.", -1)
const _hoisted_165 = /*#__PURE__*/_createVNode("div", { class: "row " }, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("b", null, "Example:")
  ]),
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("b", null, "Country:"),
    /*#__PURE__*/_createTextVNode(" Nigeria")
  ]),
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("b", null, "Region/State:"),
    /*#__PURE__*/_createTextVNode(" Abia")
  ]),
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("b", null, "City/LGA:"),
    /*#__PURE__*/_createTextVNode(" Aba North")
  ])
], -1)
const _hoisted_166 = /*#__PURE__*/_createTextVNode("Please click ")
const _hoisted_167 = /*#__PURE__*/_createTextVNode(" to update your address.")
const _hoisted_168 = {
  key: 4,
  class: "col-xxl-12"
}
const _hoisted_169 = { class: "row mb-5 text-center" }
const _hoisted_170 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Before we continue with your encashment, please update first "),
  /*#__PURE__*/_createVNode("mark", null, "KRA Number"),
  /*#__PURE__*/_createTextVNode(" in the Profile Menu.")
], -1)
const _hoisted_171 = /*#__PURE__*/_createTextVNode("Please click ")
const _hoisted_172 = /*#__PURE__*/_createTextVNode(" to update your ")
const _hoisted_173 = /*#__PURE__*/_createVNode("mark", null, "KRA Number", -1)
const _hoisted_174 = /*#__PURE__*/_createTextVNode(".")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_font = _resolveComponent("font")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _createVNode("div", _hoisted_1, [
      _withDirectives(_createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            (_ctx.isRequiredNigeriaLGA == false && _ctx.isRequiredKenyaKRA == false)
              ? (_openBlock(), _createBlock("h2", _hoisted_5, "Encash Now (" + _toDisplayString(_ctx.usid) + ")", 1))
              : _createCommentVNode("", true),
            (_ctx.isRequiredNigeriaLGA == true || _ctx.isRequiredKenyaKRA == true)
              ? (_openBlock(), _createBlock("h2", _hoisted_6, "Oops!"))
              : _createCommentVNode("", true),
            _createVNode("div", {
              class: "btn btn-sm btn-icon btn-active-color-primary",
              ref: "closeEncashmentProcessModal",
              "data-bs-dismiss": "modal",
              onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.closeModal();})
            }, [
              _createVNode("span", _hoisted_7, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
              ])
            ], 512)
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              (_ctx.hasPendingChinatrustOTP == false && _ctx.hasPendingEncashmentOTP == false && _ctx.isRequiredNigeriaLGA == false && _ctx.isRequiredKenyaKRA == false)
                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                    (_ctx.isShowEncashmentDestinationDropdown == true)
                      ? (_openBlock(), _createBlock("div", _hoisted_11, [
                          _createVNode("div", _hoisted_12, [
                            _createVNode("table", _hoisted_13, [
                              _hoisted_14,
                              _createVNode("tbody", null, [
                                _createVNode("tr", null, [
                                  _hoisted_15,
                                  _createVNode("td", null, [
                                    _createVNode("p", _hoisted_16, [
                                      _createVNode("a", _hoisted_17, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.availablebalance).toFixed(2))) + " " + _toDisplayString(_ctx.currency), 1)
                                    ])
                                  ]),
                                  _hoisted_18
                                ]),
                                (_ctx.isShowEncashmentDestinationDropdown == true && _ctx.ccode == 0)
                                  ? (_openBlock(), _createBlock("tr", _hoisted_19, [
                                      _hoisted_20,
                                      _createVNode("td", null, [
                                        _createVNode("p", _hoisted_21, [
                                          _createVNode("a", _hoisted_22, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.wbalance_mlc).toFixed(2))) + " " + _toDisplayString(_ctx.currency), 1)
                                        ])
                                      ]),
                                      _createVNode("td", _hoisted_23, [
                                        _createVNode("p", _hoisted_24, [
                                          _createVNode("span", null, [
                                            (_ctx.isShowMLCEncashment)
                                              ? (_openBlock(), _createBlock("a", {
                                                  key: 0,
                                                  class: "btn btn-sm btn-success",
                                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setEncashmentFrom('MLC')))
                                                }, " Withdrawable "))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.isShowEncashmentDestinationDropdown == true && _ctx.ccode == 0)
                                  ? (_openBlock(), _createBlock("tr", _hoisted_25, [
                                      _hoisted_26,
                                      _createVNode("td", null, [
                                        _createVNode("p", _hoisted_27, [
                                          _createVNode("a", _hoisted_28, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.wbalance_drc).toFixed(2))) + " " + _toDisplayString(_ctx.currency), 1)
                                        ])
                                      ]),
                                      _createVNode("td", _hoisted_29, [
                                        _createVNode("p", _hoisted_30, [
                                          _createVNode("span", null, [
                                            _createVNode("a", {
                                              class: "btn btn-sm btn-success",
                                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setEncashmentFrom('DRC')))
                                            }, " Withdrawable ")
                                          ])
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isShowEncashmentDestinationDropdown == true && _ctx.showEncashmentForm == true)
                      ? (_openBlock(), _createBlock("div", _hoisted_31, [
                          _hoisted_32,
                          _createVNode("div", _hoisted_33, [
                            _withDirectives(_createVNode("input", {
                              type: "number",
                              class: "form-control form-control-solid",
                              placeholder: "Enter amount here...",
                              id: "encashment_amount",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.model_encashment_amount = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.model_encashment_amount]
                            ])
                          ]),
                          _hoisted_34
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createVNode("div", _hoisted_37, [
                        (_ctx.isShowEncashmentDestinationDropdown == false)
                          ? (_openBlock(), _createBlock("p", _hoisted_38, "Encashment is currently unavailable because you have reached the maximum number of OTPs per day. Please try again at 12 midnight of the next day. Sorry for the inconvenience."))
                          : _createCommentVNode("", true),
                        (_ctx.isShowEncashmentDestinationDropdown == true && _ctx.showEncashmentForm == true)
                          ? _withDirectives((_openBlock(), _createBlock("select", {
                              key: 1,
                              class: "form-select form-select-solid",
                              id: "destination",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.model_destination_selected = $event)),
                              onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.destinationChange()))
                            }, [
                              _hoisted_39,
                              (_ctx.isAllowBankEncashment == true && _ctx.isShowEncashmentDestinationDropdown == true)
                                ? (_openBlock(), _createBlock("option", _hoisted_40, "Bank (" + _toDisplayString(_ctx.b) + ")", 1))
                                : _createCommentVNode("", true),
                              (_ctx.isAllowChequeEncashment == true && _ctx.isShowEncashmentDestinationDropdown == true)
                                ? (_openBlock(), _createBlock("option", _hoisted_41, "Cheque"))
                                : _createCommentVNode("", true),
                              (_ctx.isAllowCashEncashment == true && _ctx.isShowEncashmentDestinationDropdown == true)
                                ? (_openBlock(), _createBlock("option", _hoisted_42, "Cash"))
                                : _createCommentVNode("", true),
                              (_ctx.isAllowIbayadEncashment == true && _ctx.isShowEncashmentDestinationDropdown == true)
                                ? (_openBlock(), _createBlock("option", _hoisted_43, "BanKO ATM/ID"))
                                : _createCommentVNode("", true),
                              (_ctx.ccode == 0 && _ctx.isShowChinatrustEncashDropdown == true)
                                ? (_openBlock(), _createBlock("option", _hoisted_44, "Chinatrust"))
                                : _createCommentVNode("", true),
                              (_ctx.isShowBiboEncashDropdown == true)
                                ? (_openBlock(), _createBlock("option", _hoisted_45, "BIBO SuperApp"))
                                : _createCommentVNode("", true),
                              (_ctx.isShowMobileMoneyEncashDropdown == true)
                                ? (_openBlock(), _createBlock("option", _hoisted_46, "Mobile Money"))
                                : _createCommentVNode("", true)
                            ], 544)), [
                              [_vModelSelect, _ctx.model_destination_selected]
                            ])
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_47
                    ]),
                    (_ctx.ccode == 0 && _ctx.isShowChequeBranchDropdown == true && _ctx.isShowDivChequeBranch == true)
                      ? (_openBlock(), _createBlock("div", _hoisted_48, [
                          _hoisted_49,
                          _createVNode("div", _hoisted_50, [
                            _withDirectives(_createVNode("select", {
                              class: "form-select form-select-solid",
                              id: "chequereleasingbranch",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.chequereleasebranchcode_selected = $event))
                            }, [
                              _hoisted_51,
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.branches, (item, index) => {
                                return (_openBlock(), _createBlock("option", {
                                  key: index,
                                  value: item.branch_code
                                }, _toDisplayString(item.description), 9, ["value"]))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.chequereleasebranchcode_selected]
                            ])
                          ]),
                          _hoisted_52
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isShowBankAccounts == true)
                      ? (_openBlock(), _createBlock("div", _hoisted_53, [
                          _createVNode("div", _hoisted_54, [
                            (_ctx.bankaccountsList.length > 1)
                              ? (_openBlock(), _createBlock("div", _hoisted_55, [
                                  _hoisted_56,
                                  _withDirectives(_createVNode("select", {
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.currentlySelectedAccount = $event)),
                                    class: "form-control form-select form-select-solid",
                                    "data-kt-select2": "true",
                                    "data-placeholder": "Select an option",
                                    "data-allow-clear": "true",
                                    "data-kt-initialized": "1",
                                    onChange: _cache[9] || (_cache[9] = ($event: any) => {_ctx.updateSelectedBankAccount();})
                                  }, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bankaccountsList, (item, index) => {
                                      return (_openBlock(), _createBlock("option", {
                                        key: index,
                                        value: item.recid
                                      }, _toDisplayString(item.bank) + " - " + _toDisplayString(item.accountno), 9, ["value"]))
                                    }), 128))
                                  ], 544), [
                                    [_vModelSelect, _ctx.currentlySelectedAccount]
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode("div", _hoisted_57, [
                              (_ctx.ccode == 9)
                                ? (_openBlock(), _createBlock("label", {
                                    key: 0,
                                    class: "text-primary btn btn-link btn-sm mb-5",
                                    type: "button",
                                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showAddAccountForm()))
                                  }, _toDisplayString(_ctx.addAccountFormLabel), 1))
                                : _createCommentVNode("", true),
                              (_ctx.isShowAddAccountForm)
                                ? (_openBlock(), _createBlock("div", _hoisted_58, [
                                    _createVNode("div", _hoisted_59, [
                                      _createVNode("div", _hoisted_60, [
                                        _createVNode("div", _hoisted_61, [
                                          _withDirectives(_createVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.newaccountno = $event)),
                                            class: "form-control form-control-solid",
                                            placeholder: "Zenith Account Number"
                                          }, null, 512), [
                                            [_vModelText, _ctx.newaccountno]
                                          ])
                                        ])
                                      ]),
                                      (_ctx.isSaving == false)
                                        ? (_openBlock(), _createBlock("button", {
                                            key: 0,
                                            class: "btn btn-sm btn-primary",
                                            type: "button",
                                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.saveNewZenithAccount()))
                                          }, " Save Account "))
                                        : _createCommentVNode("", true),
                                      (_ctx.isSaving == true)
                                        ? (_openBlock(), _createBlock("button", _hoisted_62, " Saving... "))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.ccode == 0 && _ctx.isAllowCashEncashment == true && _ctx.isShowDivCashBranch == true)
                      ? (_openBlock(), _createBlock("div", _hoisted_63, [
                          _hoisted_64,
                          _createVNode("div", _hoisted_65, [
                            _withDirectives(_createVNode("select", {
                              class: "form-select form-select-solid",
                              id: "cashreleasingbranch",
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.cashreleasebranchcode_selected = $event))
                            }, [
                              _hoisted_66,
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.branches, (item, index) => {
                                return (_openBlock(), _createBlock("option", {
                                  key: index,
                                  value: item.branch_code
                                }, _toDisplayString(item.description), 9, ["value"]))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.cashreleasebranchcode_selected]
                            ])
                          ]),
                          _hoisted_67
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isShowEncashmentButtons && _ctx.isShowEncashmentDestinationDropdown == true)
                      ? (_openBlock(), _createBlock("div", _hoisted_68, [
                          _createVNode("div", _hoisted_69, [
                            _createVNode("input", {
                              type: "button",
                              class: "btn btn-sm btn-danger min-w-100px",
                              onClick: _cache[14] || (_cache[14] = ($event: any) => {_ctx.reset_encashment();}),
                              id: "cancel",
                              disabled: _ctx.isCancelBtnDisabled,
                              value: "Reset"
                            }, null, 8, ["disabled"]),
                            _hoisted_70,
                            _createVNode("input", {
                              type: "button",
                              class: "btn btn-sm btn-success min-w-100px",
                              onClick: _cache[15] || (_cache[15] = ($event: any) => {_ctx.process_encashment();}),
                              id: "encash",
                              disabled: _ctx.isEncashBtnDisabled,
                              value: "Encash"
                            }, null, 8, ["disabled"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isShowEncashmentConfirmation)
                      ? (_openBlock(), _createBlock("div", _hoisted_71, [
                          _createVNode("div", _hoisted_72, [
                            _hoisted_73,
                            _createVNode("div", _hoisted_74, [
                              _hoisted_75,
                              _createVNode("p", null, [
                                _hoisted_76,
                                _createVNode("strong", _hoisted_77, _toDisplayString(_ctx.display_b), 1)
                              ]),
                              _createVNode("p", null, [
                                _hoisted_78,
                                _createVNode("strong", _hoisted_79, _toDisplayString(_ctx.display_ba), 1)
                              ]),
                              _hoisted_80
                            ]),
                            _hoisted_81
                          ]),
                          _createVNode("div", _hoisted_82, [
                            _createVNode("div", _hoisted_83, [
                              _createVNode("a", {
                                href: "#",
                                class: "btn btn-sm btn-danger min-w-100px",
                                "data-bs-toggle": "modal",
                                onClick: _cache[16] || (_cache[16] = ($event: any) => {_ctx.cancel_encashmentconfirmation();}),
                                id: "cancel"
                              }, " Cancel "),
                              _hoisted_84,
                              _createVNode("a", {
                                href: "#",
                                class: "btn btn-sm btn-info min-w-100px",
                                "data-bs-toggle": "modal",
                                onClick: _cache[17] || (_cache[17] = ($event: any) => {_ctx.process_ibayadencashment();}),
                                id: "encash"
                              }, " Proceed ")
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isShowBiboEncashmentConfirmation)
                      ? (_openBlock(), _createBlock("div", _hoisted_85, [
                          _createVNode("div", _hoisted_86, [
                            _hoisted_87,
                            _createVNode("div", _hoisted_88, [
                              _hoisted_89,
                              _createVNode("p", null, [
                                _hoisted_90,
                                _createVNode("strong", _hoisted_91, _toDisplayString(_ctx.bibo_mobile), 1)
                              ]),
                              _hoisted_92
                            ]),
                            _hoisted_93
                          ]),
                          _createVNode("div", _hoisted_94, [
                            _createVNode("div", _hoisted_95, [
                              _createVNode("a", {
                                href: "#",
                                class: "btn btn-sm btn-danger min-w-100px",
                                "data-bs-toggle": "modal",
                                onClick: _cache[18] || (_cache[18] = ($event: any) => {_ctx.cancel_encashmentconfirmation();}),
                                id: "cancel"
                              }, " Cancel "),
                              _hoisted_96,
                              _createVNode("a", {
                                href: "#",
                                class: "btn btn-sm btn-info min-w-100px",
                                "data-bs-toggle": "modal",
                                onClick: _cache[19] || (_cache[19] = ($event: any) => {_ctx.process_ibayadencashment();}),
                                id: "encash"
                              }, " Proceed ")
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isShowMobileMoneyEncashmentConfirmation)
                      ? (_openBlock(), _createBlock("div", _hoisted_97, [
                          _createVNode("div", _hoisted_98, [
                            _hoisted_99,
                            _createVNode("div", _hoisted_100, [
                              _hoisted_101,
                              _createVNode("p", null, [
                                _hoisted_102,
                                _createVNode("strong", _hoisted_103, _toDisplayString(_ctx.mobile_money_accountno), 1)
                              ]),
                              _hoisted_104
                            ]),
                            _hoisted_105
                          ]),
                          _createVNode("div", _hoisted_106, [
                            _createVNode("div", _hoisted_107, [
                              _createVNode("a", {
                                href: "#",
                                class: "btn btn-sm btn-danger min-w-100px",
                                "data-bs-toggle": "modal",
                                onClick: _cache[20] || (_cache[20] = ($event: any) => {_ctx.cancel_encashmentconfirmation();}),
                                id: "cancel"
                              }, " Cancel "),
                              _hoisted_108,
                              _createVNode("a", {
                                href: "#",
                                class: "btn btn-sm btn-info min-w-100px",
                                "data-bs-toggle": "modal",
                                onClick: _cache[21] || (_cache[21] = ($event: any) => {_ctx.process_ibayadencashment();}),
                                id: "encash"
                              }, " Proceed ")
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isShowChequeEncashmentConfirmation)
                      ? (_openBlock(), _createBlock("div", _hoisted_109, [
                          _createVNode("div", _hoisted_110, [
                            _hoisted_111,
                            _createVNode("div", _hoisted_112, [
                              _hoisted_113,
                              _createVNode("p", _hoisted_114, [
                                _hoisted_115,
                                _createVNode("strong", _hoisted_116, _toDisplayString(_ctx.fname), 1)
                              ]),
                              _createVNode("p", _hoisted_117, [
                                _hoisted_118,
                                _createVNode("strong", _hoisted_119, _toDisplayString(_ctx.lname), 1)
                              ]),
                              (_ctx.showChequeWillBeReleased == true)
                                ? (_openBlock(), _createBlock("p", _hoisted_120, "*Check will be released to the account owner only.*"))
                                : _createCommentVNode("", true),
                              _hoisted_121
                            ]),
                            _hoisted_122
                          ]),
                          _createVNode("div", _hoisted_123, [
                            _createVNode("label", _hoisted_124, [
                              _createVNode("input", {
                                type: "checkbox",
                                id: "checkboxCHEQUE",
                                value: "",
                                onClick: _cache[22] || (_cache[22] = ($event: any) => {_ctx.checkBoxValidator($event);})
                              }),
                              _hoisted_125
                            ])
                          ]),
                          _createVNode("div", _hoisted_126, [
                            _createVNode("div", _hoisted_127, [
                              _createVNode("input", {
                                type: "button",
                                class: "btn btn-sm btn-danger min-w-100px",
                                "data-bs-toggle": "modal",
                                onClick: _cache[23] || (_cache[23] = ($event: any) => {_ctx.cancel_encashmentconfirmation();}),
                                id: "cancel",
                                disabled: _ctx.isCancelChequeBtnDisabled,
                                value: "Cancel"
                              }, null, 8, ["disabled"]),
                              _hoisted_128,
                              _createVNode("input", {
                                type: "button",
                                class: "btn btn-sm btn-info min-w-100px",
                                "data-bs-toggle": "modal",
                                onClick: _cache[24] || (_cache[24] = ($event: any) => {_ctx.process_chequeencashment();}),
                                id: "btnChequeProceed",
                                disabled: _ctx.isChequeEncashBtnDisabled,
                                value: "Proceed"
                              }, null, 8, ["disabled"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isShowCashEncashmentConfirmation)
                      ? (_openBlock(), _createBlock("div", _hoisted_129, [
                          _createVNode("div", _hoisted_130, [
                            _hoisted_131,
                            _createVNode("div", _hoisted_132, [
                              (_ctx.ccode == 6)
                                ? (_openBlock(), _createBlock("p", _hoisted_133, "Please be reminded that you can only claim your cash encashment at our Dubai or Abu Dhabi office."))
                                : _createCommentVNode("", true),
                              (_ctx.ccode == 2)
                                ? (_openBlock(), _createBlock("p", _hoisted_134, "Please be reminded that you can only claim your cash encashment at our Brunei office."))
                                : _createCommentVNode("", true)
                            ]),
                            _hoisted_135
                          ]),
                          _createVNode("div", _hoisted_136, [
                            _createVNode("div", _hoisted_137, [
                              _createVNode("a", {
                                href: "#",
                                class: "btn btn-sm btn-danger min-w-100px",
                                "data-bs-toggle": "modal",
                                onClick: _cache[25] || (_cache[25] = ($event: any) => {_ctx.cancel_encashmentconfirmation();}),
                                id: "cancel"
                              }, " Cancel "),
                              _hoisted_138,
                              _createVNode("a", {
                                href: "#",
                                class: "btn btn-sm btn-info min-w-100px",
                                "data-bs-toggle": "modal",
                                onClick: _cache[26] || (_cache[26] = ($event: any) => {_ctx.process_cashencashment();}),
                                id: "btnCashProceed"
                              }, " Proceed ")
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_ctx.hasPendingChinatrustOTP == true && _ctx.isRequiredNigeriaLGA == false && _ctx.isRequiredKenyaKRA == false)
                  ? (_openBlock(), _createBlock("div", _hoisted_139, [
                      _hoisted_140,
                      _createVNode("div", _hoisted_141, [
                        _createVNode("div", _hoisted_142, [
                          _withDirectives(_createVNode("input", {
                            type: "number",
                            class: "form-control form-control-solid",
                            id: "chinatrust_otp",
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.model_chinatrust_otp = $event)),
                            placeholder: "Enter OTP"
                          }, null, 512), [
                            [_vModelText, _ctx.model_chinatrust_otp]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_143, [
                        _hoisted_144,
                        _createVNode("div", _hoisted_145, [
                          _createVNode("a", {
                            href: "#",
                            class: "btn btn-sm btn-success",
                            "data-bs-toggle": "modal",
                            onClick: _cache[28] || (_cache[28] = ($event: any) => {_ctx.process_chinatrustOTP();})
                          }, " Proceed ")
                        ]),
                        _hoisted_146
                      ])
                    ]))
                  : (_ctx.hasPendingEncashmentOTP == true && _ctx.isRequiredNigeriaLGA == false && _ctx.isRequiredKenyaKRA == false)
                    ? (_openBlock(), _createBlock("div", _hoisted_147, [
                        (_ctx.need_cheque_id_upload == false)
                          ? (_openBlock(), _createBlock("div", _hoisted_148, [
                              _hoisted_149
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.need_cheque_id_upload == false)
                          ? (_openBlock(), _createBlock("div", _hoisted_150, [
                              _createVNode("div", _hoisted_151, [
                                _withDirectives(_createVNode("input", {
                                  type: "number",
                                  class: "form-control form-control-solid",
                                  id: "encashment_otp",
                                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.model_encashment_otp = $event)),
                                  placeholder: "Enter OTP"
                                }, null, 512), [
                                  [_vModelText, _ctx.model_encashment_otp]
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.need_cheque_id_upload == false)
                          ? (_openBlock(), _createBlock("div", _hoisted_152, [
                              _hoisted_153,
                              _createVNode("div", _hoisted_154, [
                                _createVNode("a", {
                                  href: "#",
                                  class: "btn btn-sm btn-success",
                                  "data-bs-toggle": "modal",
                                  onClick: _cache[30] || (_cache[30] = ($event: any) => {_ctx.process_encashmentOTP();})
                                }, " Proceed ")
                              ]),
                              _hoisted_155
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.need_cheque_id_upload == true && _ctx.need_cheque_id_selfie_upload == false && _ctx.currentlyUploading == false)
                          ? (_openBlock(), _createBlock("div", _hoisted_156, [
                              _hoisted_157,
                              _createVNode("input", {
                                type: "file",
                                id: "cheque_id",
                                ref: "cheque_id",
                                accept: ".png, .jpg, .jpeg",
                                onChange: _cache[31] || (_cache[31] = ($event: any) => (_ctx.handleChequeIDUpload()))
                              }, null, 544)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.need_cheque_id_upload == true && _ctx.need_cheque_id_selfie_upload == true && _ctx.currentlyUploading == false)
                          ? (_openBlock(), _createBlock("div", _hoisted_158, [
                              _hoisted_159,
                              _createVNode("input", {
                                type: "file",
                                id: "cheque_id_selfie",
                                ref: "cheque_id_selfie",
                                accept: ".png, .jpg, .jpeg",
                                onChange: _cache[32] || (_cache[32] = ($event: any) => (_ctx.handleChequeIDSelfieUpload()))
                              }, null, 544)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.currentlyUploading == true)
                          ? (_openBlock(), _createBlock("div", _hoisted_160, [
                              _createVNode("p", null, [
                                _createVNode(_component_font, {
                                  color: "green",
                                  size: "5"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_161
                                  ]),
                                  _: 1
                                })
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_ctx.isRequiredNigeriaLGA == true)
                      ? (_openBlock(), _createBlock("div", _hoisted_162, [
                          _createVNode("div", _hoisted_163, [
                            _hoisted_164,
                            _hoisted_165,
                            _createVNode("p", null, [
                              _hoisted_166,
                              _createVNode("a", {
                                onClick: _cache[33] || (_cache[33] = ($event: any) => {_ctx.goToProfilePage();}),
                                "data-bs-dismiss": "modal",
                                href: "javascript:void(0);"
                              }, "here"),
                              _hoisted_167
                            ])
                          ])
                        ]))
                      : (_ctx.isRequiredKenyaKRA == true)
                        ? (_openBlock(), _createBlock("div", _hoisted_168, [
                            _createVNode("div", _hoisted_169, [
                              _hoisted_170,
                              _createVNode("p", null, [
                                _hoisted_171,
                                _createVNode("a", {
                                  onClick: _cache[34] || (_cache[34] = ($event: any) => {_ctx.goToProfilePage();}),
                                  "data-bs-dismiss": "modal",
                                  href: "javascript:void(0);"
                                }, "here"),
                                _hoisted_172,
                                _hoisted_173,
                                _hoisted_174
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
            ])
          ])
        ])
      ], 512), [
        [_vShow, !_ctx.loading]
      ])
    ])
  ], 64))
})